import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help-introduction',
  imports: [CommonModule],
  templateUrl: './help-introduction.component.html',
  styleUrl: './help-introduction.component.scss'
})
export class HelpIntroductionComponent implements OnInit {
  selectedSection = 'introduction';
  introExpanded = true;

  constructor(private navigationService: HelpNavigationService) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.next('introduction');

    this.navigationService.selectedSection.subscribe(section => {
      this.selectedSection = section;
    });

  }

  toggleMenu(): void {

    this.introExpanded =
      !this.introExpanded;

  }

  changeSection(section: string): void {

    this.selectedSection = section;

    this.navigationService.selectedSection.next(section);

    setTimeout(() => {

      const element =
        document.getElementById(section);

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 50);

  }

}
